module.exports = __webpack_public_path__ + "d4c0b303/img/arrow-left-icon.785c715c.svg";